import { render, staticRenderFns } from "./TaskAutocomplete.vue?vue&type=template&id=51f26ad6&"
import script from "./TaskAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./TaskAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports